import { ChangeEventHandler } from 'react';

import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';

const LICENSE_AUTO_RENEWAL_TITLE = 'Auto renew license?';
const LICENSE_AUTO_RENEWAL_CHECKBOX_LABEL = 'This license does not need an end date.';

export type LicenseAutoRenewalCheckboxProps = {
    checked: boolean;
    changeHandler: (value: boolean) => void;
    testId?: string;
}

export const LicenseAutoRenewalCheckbox = ({
    checked,
    changeHandler,
    testId
}: LicenseAutoRenewalCheckboxProps) => {
    const handleCheckboxChange: ChangeEventHandler<HTMLInputElement> = event => {
        changeHandler(event.target.checked);
    };
    return (
        <FormGroup>
            <Typography variant="subtitle2" gutterBottom component="div">
                <Box sx={{ fontWeight: 'bold' }}>{LICENSE_AUTO_RENEWAL_TITLE}</Box>
            </Typography>
            <FormControlLabel
                control={<Checkbox data-testid={testId} checked={checked} onChange={handleCheckboxChange} />}
                label={
                    <Typography variant="body2" gutterBottom component="div">
                        {LICENSE_AUTO_RENEWAL_CHECKBOX_LABEL}
                    </Typography>
                }
            />
        </FormGroup>
    );
};
